<template>
    <div class="modal fade " id="purchaseOrderDiscountModal">
        <div class="modal-dialog modal-dialog-centered modal-md modal-dialog-scrollable">
            <div class="modal-content">

                <!-- Modal Header -->
                <div class="modal-header bg-soft-info">
                    <h5 class="modal-title">Discount</h5>
                    <button type="button" class="close" data-dismiss="modal"><i  class="ri-close-line"></i></button>
                </div>

                <!-- Modal body -->
                <div class="modal-body">
                    <div v-if="errorMessage" class="alert alert-danger alert-dismissible">
                        <a href="#" class="close" data-dismiss="alert" aria-label="close">&times;</a>
                        <ul>
                            <li>{{errorMessage}}</li>
                        </ul>
                    </div>
                    <div v-if="commonErrors.length !=0" class="alert alert-danger alert-dismissible">
                        <a href="#" class="close" data-dismiss="alert" aria-label="close">&times;</a>
                        <ul>
                            <li v-for="(v, k) in commonErrors" :key="k">
                                <p v-for="error in v" :key="error" class="text-sm">
                                    {{ error }}
                                </p>
                            </li>
                        </ul>
                    </div>
                    <form>
                        <div class="form-group">
                            <label for="isPercentage">Discount Type</label>
                            <select class="form-control" v-model="discountData.isPercentage" id="isPercentage">
                                <option>Select</option>
                                <option value="0">Amount</option>
                                <option value="1">Percentage</option>
                            </select>
                        </div>
                        <div class="form-group">
                            <label for="amount">Discount Value</label>
                            <input type="text" class="form-control" placeholder="" v-model="discountData.amount" id="amount">
                        </div>

                        <div class="form-group">
                            <label for="reason">Reason</label>
                            <textarea class="form-control" rows="1" v-model="discountData.reason" id="reason"></textarea>
                            <p>Your customers can see the reason</p>
                        </div>

                        <div  class="mt-3 text-right">
                            <button type="button" class="btn btn-danger me-1" data-dismiss="modal">Cancel</button>
                            <button type="button" class="btn btn-primary close-modal" v-on:click="save" :class="{'disabled': this.loading}">Save</button>
                        </div>
                    </form>

                </div>



            </div>
        </div>
    </div>
</template>

<script>
import {mapState, mapActions, mapGetters} from 'vuex';
import axios from "axios";

export default {
    name: "PurchaseOrderDiscountModal",
    props: ['order', 'sub_total_cost'],
    created() {
        if(this.order && this.order.discounts.length > 0) {
            this.discountData = _.cloneDeep(this.order.discounts[0]);
        }
    },
    mounted() {

    },
    data() {
        return {
            submitted: false,
            discountData: {
                id: null,
                purchase_order_id: null,
                isPercentage: false,
                amount: 0.00,
                reason: null,
            }
        }
    },
    methods: {
        ...mapActions([
            'setCommonErrors',
            'setErrorMessage',
            'setSuccessMessage',
            'setLoading',
        ]),
        save() {
            let amount = this.discountData.amount;
            if(this.discountData.isPercentage) {
                amount = this.sub_total_cost * this.discountData.amount / 100;
            }

            if(amount > this.sub_total_cost) {
                this.setErrorMessage("Discount amount must be less than total amount!");
                return;
            }

            let self = this;
            this.setLoading(true);
            this.setCommonErrors([]);
            this.setErrorMessage(null);

            let apiUrl = window.route('po.discount.store', {id: this.order.id});

            if(this.order.discounts.length > 0 && this.order.discounts[0].id) {
                apiUrl = window.route('po.discount.update', {id: this.order.id, discount_id: this.order.discounts[0].id});
            }
            return axios.post(apiUrl, this.discountData, {
                validateStatus: function (status) {
                    return status < 500; // Resolve only if the status code is less than 500
                }
            })
                .then(({data}) => {
                    if(data.data) {
                        self.setSuccessMessage(data.message);
                        this.discountData = data.data;
                        setTimeout(() => {
                            self.setSuccessMessage(null);
                        }, 5000);
                        this.$emit('discountUpdated', data.data);
                        $('#purchaseOrderDiscountModal').modal('hide');
                    } else {
                        self.setErrorMessage(data.errorMessage);
                        if (data.errors) {
                            self.setCommonErrors(data.errors);
                        }
                    }
                })
                .catch((error) => {
                    self.setErrorMessage(error.response && error.response.errorMessage ? error.response.errorMessage : error.message);

                })
                .finally(() => {
                    self.setLoading(false);

                });
        },

    },
    computed: {
        ...mapState([
            'userState'
        ]),
        ...mapGetters([
            'isAuth',
            'getAuthUser',
            'commonErrors',
            'errorMessage',
            'successMessage',
            'loading',
        ])
    }
}
</script>

<style scoped>

</style>
